<template>
    <div v-if="$store.state.isModalOpen" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h4 class="mb-0">Employee Offboarding Approval</h4>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row gy-2 px-2">
                    <div class="col-12">
                      <label class="align-middle">Remarks</label>
                      <input
                          class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                          tabindex="1"
                          type="text"
                          required
                          placeholder="Remarks...."
                          v-model="formData.remarks"
                      >
                    </div>
                  </div>

                  <div class="col-12 text-center">
                    <hr class="mt-2">
                    <button :disabled="loading"  class="btn btn-primary me-1 mt-1" @click="handleSubmit('hold')">
                      Hold
                    </button>
                    <button :disabled="loading"  class="btn btn-success me-1 mt-1" @click="handleSubmit('approved')">
                      Approved
                    </button>
                    <button @click.prevent="onClickClose" class="btn btn-outline-secondary mt-1 waves-effect">
                      Cancel
                    </button>
                  </div>
               </div>
         </div>
      </div>
      <Loader v-if="loader"/>
    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, ref} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    }
});

const emit = defineEmits(['getOffBoardingList']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const contactProfile = ref(null);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const {
  updateEmployeeOffBoardingApprovalAssignUser
} = handleHrPayroll()

const handleSubmit = async (status) => {
  loading.value = true;
  let offBoardingData = {};
  offBoardingData.id = props.formData.employee_off_boarding_log_id;
  offBoardingData.remarks = props.formData.remarks;
  offBoardingData.status = status;

  let query = getQuery()
  await updateEmployeeOffBoardingApprovalAssignUser(offBoardingData, offBoardingData.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getOffBoardingList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
    $store.state.isModalOpen = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

</script>
